/**
 * BonusCapturedBadge Component
 *
 * Phase 7.9.4.1: Bonus Piece Captured Marker
 *
 * Displays a persistent gold/yellow badge with star icon when a player
 * has captured the bonus piece. This badge:
 * - Appears immediately after bonus piece destruction
 * - Persists for the remainder of the game
 * - Uses gold/yellow styling to match bonus announcement
 * - Visible to both players
 * - Compact design for minimal real estate
 *
 * Props:
 * @param {boolean} hasCapturedBonus - Whether the player captured the bonus piece
 */

import { COPY } from '../copy';

export default function BonusCapturedBadge({ hasCapturedBonus }) {
  // Don't render if bonus hasn't been captured
  if (!hasCapturedBonus) {
    return null;
  }

  return (
    <span
      data-testid="bonus-captured-badge"
      aria-label={COPY.bonusCaptured.badge.ariaLabel}
      role="status"
      className="inline-flex items-center gap-1 px-2 py-1 rounded-full border-2 border-yellow-400 text-yellow-400 bg-yellow-900/20 shadow-lg shadow-yellow-400/50 text-xs font-bold"
    >
      <span data-testid="bonus-star-icon" aria-hidden="true">
        ★
      </span>
      <span>{COPY.bonusCaptured.badge.text}</span>
    </span>
  );
}
